import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useRegisterItems, useTenancy } from '@/contexts/TenancyContext';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { handleNavigation } from '@/utils/navigation-utils';

export const Registers: React.FC = () => {
  const { registerItems, loading } = useRegisterItems();
  const { activeTenancy } = useTenancy();
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Registers</h1>
      {loading ? (
        <p className="text-muted-foreground">Loading registers...</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-1 md:max-xl:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
          {registerItems.map((item, idx) => {
            const Icon = item.icon;
            return (
              <Card
                key={idx}
                className="cursor-pointer transition-all duration-300 hover:shadow-md border border-border hover:border-primary/30 h-[6rem] overflow-hidden flex items-center"
                onClick={(e) => {
                  e.preventDefault();
                  if (item.url) {
                    // Use handleNavigation to support SPA navigation with routeName
                    handleNavigation(item.url, navigate, e, item.routeName);
                  }
                }}
              >
                <CardHeader className="flex flex-row items-center justify-center gap-4 px-4 w-full h-full">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-muted dark:bg-muted/40 flex items-center justify-center text-primary text-xl">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="flex-1">
                    <CardTitle className="text-lg md:text-lg sm:text-sm">{item.title}</CardTitle>
                    <CardDescription className="mt-1 text-sm md:text-sm sm:text-xs">{item.subtitle}</CardDescription>
                  </div>
                  <div className="flex-shrink-0 text-primary">
                    <i className="fa-duotone fa-arrow-right" aria-hidden="true" />
                  </div>
                </CardHeader>
              </Card>

            );
          })}
        </div>
      )}
    </div>
  );
};

export default Registers;
